export default __webpack_public_path__ + "static/media/33.7adf058f.png";